import React, { forwardRef } from 'react';
/**
 * A simple mesh plane component for rendering flat surfaces in 3D space.
 * Useful for creating basic geometric elements or custom rendered content.
 *
 * @component
 * @example
 * ```tsx
 * <Plane
 *   material={myMaterial}
 *   width={100}
 *   height={100}
 * />
 * ```
 *
 * @param {MeshProps} props - The mesh properties
 * @param {Material} [props.material] - Material to apply to the mesh
 * @param {React.ReactNode} props.children - Child elements
 * @param {React.Ref<Object3D>} ref - Forward ref to access the underlying 3D object
 * @returns {React.ReactElement} A mesh plane element
 */
export const Plane = forwardRef((props, ref) => {
    return React.createElement('mesh', Object.assign(Object.assign({}, props), { ref: ref }), props.children);
});
